import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { OrganizationBreakdown } from '@/tumeloshared'
import { Payload } from '../../payload'

interface State {
  topFive: Payload<OrganizationBreakdown>
}

const initialState: State = {
  topFive: 'not-initialised',
}

const topOrganizationsSlice = createSlice({
  name: 'top organizations',
  initialState,
  reducers: {
    setTopFive: (state, action: PayloadAction<OrganizationBreakdown>) => {
      state.topFive = action.payload
    },
    setTopFivePending: (state) => {
      state.topFive = 'pending'
    },
    setTopFiveError: (state) => {
      state.topFive = 'error'
    },
    resetTopFive: (state) => {
      state.topFive = 'not-initialised'
    },
  },
})

export const { setTopFive, setTopFivePending, setTopFiveError, resetTopFive } = topOrganizationsSlice.actions

export default topOrganizationsSlice.reducer
